import { render, staticRenderFns } from "./AwardWinner.vue?vue&type=template&id=67dcf0d6&"
import script from "./AwardWinner.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AwardWinner.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67dcf0d6')) {
      api.createRecord('67dcf0d6', component.options)
    } else {
      api.reload('67dcf0d6', component.options)
    }
    module.hot.accept("./AwardWinner.vue?vue&type=template&id=67dcf0d6&", function () {
      api.rerender('67dcf0d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/AwardWinner/AwardWinner.vue"
export default component.exports